import lodash from "lodash";

// TYPES

export const FETCH_SUBSCRIPTION_DETAILS_OF_USER =
    "FETCH_SUBSCRIPTION_DETAILS_OF_USER";
export const UPDATE_SUBCRIBED_DETAIL = "UPDATE_SUBCRIBED_DETAIL";
export const FETCH_ALL_TEMPS_FROM_DB = "FETCH_ALL_TEMPS_FROM_DB";
export const SET_FLYER_TYPES_AND_EVENTS = "SET_FLYER_TYPES_AND_EVENTS";
export const INIT_DROP_DOWN_LISTS = "INIT_DROP_DOWN_LISTS";
export const OPEN_CLOSE_DROP_DOWN = "OPEN_CLOSE_DROP_DOWN";
export const SELECT_CATEGORY_DROP_DOWN = "SELECT_CATEGORY_DROP_DOWN";
export const SELECT_EVENT_DROP_DOWN = "SELECT_EVENT_DROP_DOWN";
export const UPDATE_SELECTED_TEMP_DATA = "UPDATE_SELECTED_TEMP_DATA";
export const UPDATE_INPUT_IN_SELECTED_TEMP_DATA =
    "UPDATE_INPUT_IN_SELECTED_TEMP_DATA";
export const UPDATE_IMAGE_IN_SELECTED_TEMP_DATA =
    "UPDATE_IMAGE_IN_SELECTED_TEMP_DATA";
export const REMOVE_IMAGE_IN_SELECTED_TEMP_DATA =
    "REMOVE_IMAGE_IN_SELECTED_TEMP_DATA";
export const UPDATE_FEEDBACK_FORM_DATA = "UPDATE_FEEDBACK_FORM_DATA";
export const SAVE_DATA_TO_DB_FIRST_TIME = "SAVE_DATA_TO_DB_FIRST_TIME";
export const SAVE_DATA_TO_DB = "SAVE_DATA_TO_DB";
export const SET_OID_FIRST_TIME = "SET_OID_FIRST_TIME";
export const SET_FORM_SCHEMA_FIRST_TIME = "SET_FORM_SCHEMA_FIRST_TIME";
export const SET_FORM_SCHEMA = "SET_FORM_SCHEMA";
export const UPDATE_CREATED_FLYER_URL = "UPDATE_CREATED_FLYER_URL";
export const RESET_TO_INITIAL_STATE = "RESET_TO_INITIAL_STATE";
export const RESET_FORMSCHEMA_TO_INITIAL_STATE = "RESET_FORMSCHEMA_TO_INITIAL_STATE";
export const HANDLE_FLYER_PAGE_CHANGE = "HANDLE_FLYER_PAGE_CHANGE";
// ACTIONS

export const fetchSubscriptionDetialsOfUser = (payload) => ({
    type: FETCH_SUBSCRIPTION_DETAILS_OF_USER,
    payload,
});

export const updateSubscrbedDetail = (payload) => ({
    type: UPDATE_SUBCRIBED_DETAIL,
    payload,
});

export const fetchAllTemps = (payload) => ({
    type: FETCH_ALL_TEMPS_FROM_DB,
    payload,
});

export const setTypesAndEvents = (payload) => ({
    type: SET_FLYER_TYPES_AND_EVENTS,
    payload,
});

export const initDropDownLists = () => ({
    type: INIT_DROP_DOWN_LISTS,
    payload: "Digital Flyer",
});

export const handleDDOpen = (payload) => ({
    type: OPEN_CLOSE_DROP_DOWN,
    payload,
});

export const handleCatDDSelect = (payload) => ({
    type: SELECT_CATEGORY_DROP_DOWN,
    payload,
});

export const handleEvntDDSelect = (payload) => ({
    type: SELECT_EVENT_DROP_DOWN,
    payload,
});

export const handleTempSelect = (payload) => ({
    type: UPDATE_SELECTED_TEMP_DATA,
    payload,
});

export const handleFlyerFormInput = (payload) => ({
    type: UPDATE_INPUT_IN_SELECTED_TEMP_DATA,
    payload,
});

export const handleFlyerImageUpload = (payload) => ({
    type: UPDATE_IMAGE_IN_SELECTED_TEMP_DATA,
    payload,
});

export const handleFlyerImageRemove = (payload) => ({
    type: REMOVE_IMAGE_IN_SELECTED_TEMP_DATA,
    payload,
});

export const handleCreatedFlyerUrlUpdate = (payload) => ({
    type: UPDATE_CREATED_FLYER_URL,
    payload,
});

export const handleFeedbackFormupdate = (payload) => ({
    type: UPDATE_FEEDBACK_FORM_DATA,
    payload,
});

export const setOidFirstTime = (payload) => ({
    type: SET_OID_FIRST_TIME,
    payload,
});

export const setFormSchemaFirstTime = (payload) => ({
    type: SET_FORM_SCHEMA_FIRST_TIME,
    payload,
});
export const setFormSchema = (payload) => ({ type: SET_FORM_SCHEMA, payload });

export const saveDataToDBFirstTime = (payload) => ({
    type: SAVE_DATA_TO_DB_FIRST_TIME,
    payload,
});

export const saveDataToDB = (payload) => ({ type: SAVE_DATA_TO_DB, payload });

export const handleStateReset = (payload) => ({
    type: RESET_TO_INITIAL_STATE,
    payload,
});

export const handleFormschemaReset = (payload) => ({
    type: RESET_FORMSCHEMA_TO_INITIAL_STATE,
    payload,
});

export const handleFlyerPageChange = (payload) => ({
    type: HANDLE_FLYER_PAGE_CHANGE,
    payload,
});

//REDUCERS
let now = Date.now();
let randNum = Math.floor(Math.random() * 100);

let orderId = now + randNum;
export const INITIAL_STATE = {
    formSchema: {
        oid: "",
        stype: "banner",
        name: "",
        email: "",
        bannerRes: {
            finalImgUrl: "",
            dynaurl: "",
            watermarkUrl: "",
            scaledImg: "",
        },
        status: "",
        satisfactionLevel: "",
        leadType: "",
        tid: "",
        eventType: "",
        category: "",
        template_data: [],
    },

    isMarketingSuiteSubscribed: false,
    allTemps: [],
    typesAndEvents: {},
    dropDowns: [],
    selectedCat: "Digital Flyers",
    selectedEvent: "Just Listed",
    dropDowns: {
        "Category Type": {
            title: "Category Type",
            isOpen: false,
            dropDownList: [],
            selectedItem: "",
        },
        "Event Type": {
            title: "Event Type",
            isOpen: false,
            dropDownList: [],
            selectedItem: "",
        },
    },
    selectedTempData: {},
    defaultTempData: {},
    pageType: {
        pages: ["home", "payment", "payment_successful"],
        activePage: "home",
    },
};

const FlyersReducer = (state = lodash.cloneDeep(INITIAL_STATE), action) => {
    // let temp_state = { ...state };
    let temp_state = lodash.cloneDeep(state);

    switch (action.type) {
        case UPDATE_SUBCRIBED_DETAIL: {
            if (
                action.payload?.subscription_type === "marketing_suite" &&
                action.payload?.is_active
            ) {
                temp_state.isMarketingSuiteSubscribed = true;
            }
            return temp_state;
        }
        case SET_FLYER_TYPES_AND_EVENTS: {
            let formRes = action.payload.formRes;

            let formSchema = {};
            if (formRes.status === "success") {
                temp_state.formSchema = { ...formRes.data };
                formSchema = { ...formRes.data };
            }

            temp_state.typesAndEvents = action.payload.typesAndEvents;
            delete temp_state.typesAndEvents["Flyer A4"];
            temp_state.allTemps = action.payload.allTemps;
            temp_state.selectedCat =
                formSchema.category ||
                Object.keys(temp_state.typesAndEvents)[0];
            temp_state.selectedEvent = formSchema.eventType || "View All";

            temp_state.dropDowns["Category Type"].dropDownList = Object.keys(
                temp_state.typesAndEvents
            );
            temp_state.dropDowns["Category Type"].selectedItem =
                temp_state.selectedCat;
            temp_state.dropDowns["Category Type"].title =
                temp_state.selectedCat;

            temp_state.dropDowns["Event Type"].dropDownList = ["View All"];
            temp_state.dropDowns["Event Type"].dropDownList.push(
                ...Object.keys(
                    temp_state.typesAndEvents[temp_state.selectedCat]
                )
            );
            temp_state.dropDowns["Event Type"].selectedItem =
                temp_state.selectedEvent;
            temp_state.dropDowns["Event Type"].title = temp_state.selectedEvent;

            return temp_state;
        }

        case INIT_DROP_DOWN_LISTS: {
            let sequence = [
                "Just Listed",
                "Just Sold",
                "Open House",
                "Market Update",
                "Client Testimonial",
            ];

            temp_state.selectedCat = Object.keys(temp_state.typesAndEvents)[0];
            temp_state.dropDowns["Category Type"].dropDownList = Object.keys(
                temp_state.typesAndEvents
            );
            temp_state.dropDowns["Category Type"].selectedItem =
                temp_state.selectedCat;
            temp_state.dropDowns["Category Type"].title =
                temp_state.selectedCat;

            // temp_state.dropDowns["Event Type"].dropDownList = Object.keys();
            // temp_state.types.push
            return temp_state;
        }
        case OPEN_CLOSE_DROP_DOWN: {
            temp_state.dropDowns[action.payload.dd].isOpen =
                action.payload.isOpen;

            return temp_state;
        }
        case SELECT_CATEGORY_DROP_DOWN: {
            temp_state.selectedCat = action.payload.item;
            temp_state.formSchema.category = action.payload.item;

            temp_state.dropDowns[action.payload.dd].selectedItem =
                action.payload.item;

            temp_state.dropDowns[action.payload.dd].title = action.payload.item;

            temp_state.selectedEvent = 'View All';
            temp_state.formSchema.eventType = temp_state.selectedEvent;

            temp_state.dropDowns["Event Type"].dropDownList = ['View All']

            temp_state.dropDowns["Event Type"].dropDownList.push(...Object.keys(
                temp_state.typesAndEvents[temp_state.selectedCat]
            ));
            temp_state.dropDowns["Event Type"].selectedItem = 'View All';
            temp_state.dropDowns["Event Type"].title = 'View All';

            return temp_state;
        }

        case SELECT_EVENT_DROP_DOWN: {
            temp_state.selectedEvent = action.payload.item;
            temp_state.formSchema.eventType = action.payload.item;

            temp_state.dropDowns[action.payload.dd].selectedItem =
                action.payload.item;
            temp_state.dropDowns[action.payload.dd].title = action.payload.item;

            return temp_state;
        }
        case UPDATE_SELECTED_TEMP_DATA: {
            // let data = temp_state.typesAndEvents[temp_state.selectedCat][
            //     temp_state.selectedEvent
            // ].find((temp) => temp._id === action.payload.tid);

            let temp_data = lodash.cloneDeep(
                temp_state.typesAndEvents[temp_state.selectedCat][
                action.payload.event
                ]
            );

            let data = temp_data.find(
                (temp) => temp._id === action.payload.tid
            );

            let removingDefaultValFromData = lodash.cloneDeep(data);
            if (action.payload.tid === temp_state.formSchema.tid) {
                removingDefaultValFromData.template_data = lodash.cloneDeep(
                    temp_state.formSchema.template_data
                );
            } else {
                temp_state.formSchema.tid = action.payload.tid;
                for (let key in removingDefaultValFromData.template_data) {
                    let field = removingDefaultValFromData.template_data[key];
                    switch (field.type) {
                        case "image": {
                            field.fileName = "";
                            break;
                        }
                        case "text": {
                            if (
                                field.layerName == "Name*" ||
                                field.layerName == "Email Address*" ||
                                field.layerName == "Mobile Number*"
                            ) {
                                field.text = "";
                            }
                            break;
                        }
                        default:
                            break;
                    }
                }
            }

            temp_state.selectedTempData = { ...removingDefaultValFromData };
            temp_state.defaultTempData = { ...data };
            temp_state.formSchema.template_data = [
                ...removingDefaultValFromData.template_data,
            ];

            return temp_state;
        }
        case UPDATE_INPUT_IN_SELECTED_TEMP_DATA: {
            temp_state.selectedTempData.template_data[action.payload.id].text =
                action.payload.val;

            temp_state.formSchema.template_data[action.payload.id].text =
                action.payload.val;
            return temp_state;
        }

        case UPDATE_IMAGE_IN_SELECTED_TEMP_DATA: {
            temp_state.selectedTempData.template_data[
                action.payload.id
            ].fileName = action.payload.url;

            temp_state.formSchema.template_data[action.payload.id].fileName =
                action.payload.url;

            return temp_state;
        }
        case REMOVE_IMAGE_IN_SELECTED_TEMP_DATA: {
            temp_state.selectedTempData.template_data[
                action.payload.id
            ].fileName = "";

            temp_state.formSchema.template_data[action.payload.id].fileName =
                "";

            return temp_state;
        }
        case SET_OID_FIRST_TIME: {
            temp_state.formSchema.oid = action.payload.oid;
            return temp_state;
        }

        case SET_FORM_SCHEMA_FIRST_TIME: {
            temp_state.formSchema = action.payload.formSchema;
            temp_state.selectedCat = action.payload.formSchema.category;
            temp_state.selectedEvent = action.payload.formSchema.eventType;

            return temp_state;
        }

        case SET_FORM_SCHEMA: {
            temp_state.formSchema = action.payload.formSchema;
            // temp_state.selectedCat = action.payload.formSchema.category;
            // temp_state.selectedEvent = action.payload.formSchema.eventType;

            return temp_state;
        }
        case UPDATE_FEEDBACK_FORM_DATA: {
            temp_state.formSchema[action.payload.field] = action.payload.value;
            return temp_state;
        }
        case UPDATE_CREATED_FLYER_URL: {
            temp_state.formSchema.bannerRes.finalImgUrl = action.payload.url;
            temp_state.formSchema.bannerRes.dynaurl = action.payload.dynaurl;
            temp_state.formSchema.bannerRes.watermarkUrl =
                action.payload.watermarkedUrl;
            temp_state.formSchema.bannerRes.scaledImg =
                action.payload.scaledImg;
            return temp_state;
        }

        case RESET_TO_INITIAL_STATE: {
            temp_state = lodash.cloneDeep(INITIAL_STATE);

            return temp_state;
        }

        case RESET_FORMSCHEMA_TO_INITIAL_STATE: {
            temp_state.formSchema = lodash.cloneDeep(INITIAL_STATE.formSchema);

            return temp_state;
        }
        case HANDLE_FLYER_PAGE_CHANGE: {
            const { page } = action.payload;
            let temp_state = { ...state };
            temp_state.pageType.activePage = page;
            return temp_state;
        }

        default: {
            return state;
        }
    }
};

export default FlyersReducer;
